<template>
  <div class="">
    <Navbar />

    <div id="main">
      <div class="container">
        <div class="row align-items-center text-center" style="background:#000;">
          <div class="col-md-12 px-0" v-lazy-container="{ selector: 'img' }">
            <img data-src="/logo/search_demo_pic002.jpg" data-loading="/logo/search_demo_pic002.jpg"
              style="width:100%;max-height:495px;object-fit:cover;">
            <div id="centered">
              <h2>FEATURED VOICEOVER ARTISTS</h2>
              <button type="button" class="btn btn-light" @click="redirect('/searchdemos')">
                <i class="fas fa-search"></i> Search Voiceover Demos
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" style="min-height:200px; background: linear-gradient(#1b1b1b, #4e4e4e); color:#fff;">
            <div class="mb-4">
              <h4>Top Lists</h4>
            </div>
            <div class="row">
              <!-- <div class="col-lg-3 col-md-4 col-xs-6 mb-5 px-2 text-center" v-for="(val,key) in artwork_list" :key="key"> -->
              <div class="col-lg-3 col-md-4 col-xs-6 mb-5 px-2 text-center" v-for="(val, key) in top_list" :key="key">
                <img v-lazy="idiom + 'source/img/' + val.image_file" :alt="val.name + ' ' + val.lastname"
                  style="height:200px;width:100%;object-fit:cover;object-position:50% 0;">
                <div
                  style="background:linear-gradient(#7c7c7c,#000);width:100%;text-overflow: ellipsis;overflow: hidden; white-space: nowrap;">
                  <span class="font-white font-bold" style="width:100%;text-shadow: 1px 1px 5px black;">
                    {{ val.name + ' ' + val.lastname }} <i>{{ val.category_name }}</i>
                  </span>
                </div>
                <!-- @play="showDemoPopup" -->
                <audio controls controlsList="nodownload" preload="none" style="width:100%;height:35px;">
                  <source :src="idiom + 'source/audio/' + val.file_name" type="audio/mp3" />
                </audio>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>

  </div>

</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

import Swal from 'sweetalert2'; // Import SweetAlert2

export default {
  name: 'Demos',
  components: { Navbar, Footer },
  data() {
    return {
      audio: [],
      top_list: [],
    }
  },
  // created() {
  //   this.audio = this.LocalStorage("_IdiomtalentAudio", new Array());
  // },
  mounted() {
    if (!this.audio.length) {
      this.get_audio_list();
    } else {
      this.random_list();
    }
  },
  methods: {
    async get_audio_list() {
      var url = this.api + 'audio/get_audio_list/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            // this.audio = response.data.data;
            response.data.data.forEach((e) => {
              let findIndex = this.audio.findIndex(x => x.id == e.id);
              if (findIndex == -1) this.audio.push(e);
            });
            // localStorage.setItem("_IdiomtalentAudio", JSON.stringify(this.audio));

            this.random_list();
          }
        })
        .catch((error) => {
          console.error(error);
        })
    },
    random_list(n = 16) {
      if (this.audio.length < n) n = this.audio.length;

      var result = new Array(n),
        len = this.audio.length,
        taken = new Array(len);
      if (n > len)
        throw new RangeError("getRandom: more elements taken than available");
      while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = this.audio[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      // // let randomList = [];
      // result.forEach((e)=>{
      //   let findIndex = this.audio.findIndex(x => x.id == e.id);
      //   this.audio.splice(findIndex, 1);
      //   this.audio.unshift(e);
      //   // randomList.push(e);
      // });
      this.audio = result;

      this.reorder_top_list()
    },
    // reorder_top_list(){
    //   let top_list = this.audio;
    //   if(this.audio.length>1){
    //     top_list = this.audio.sort((a, b) => {
    //       if(this.ArtworkImages.includes(a.image_file) && !this.ArtworkImages.includes(b.image_file)){
    //         console.log(1);
    //         return 1
    //       }else if(!this.DefaultImages.includes(a.image_file) && this.DefaultImages.includes(b.image_file)){
    //         console.log(-1);
    //         return -1
    //       }
    //     })
    //   }
    //   this.top_list = top_list;
    // }
    reorder_top_list() {
      let top_list = this.audio;
      if (this.audio.length > 1) {
        top_list = [];
        this.audio.forEach((e) => {
          if (this.ArtworkImages.includes(e.image_file)) {
            top_list.unshift(e);
          } else if (this.DefaultImages.includes(e.image_file)) {
            top_list.push(e)
          } else {
            top_list.push(e)
          }
        });
      }
      this.top_list = top_list;
    },
    showDemoPopup(event) {
      event.preventDefault(); // Prevent audio from playing
      event.target.pause(); // Stop playback immediately

      Swal.fire({
        title: "Demos are currently being updated",
        text: "Please check back again later.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3366ff"
      });
    },
  },
  computed: {
    artwork_list() {
      return this.audio.filter((e) => {
        return !this.DefaultImages.includes(e.image_file)
      })
    }
  },
}
</script>

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff !important;
  width: 100%;
}

#detail {
  padding: 50px;
  width: 100% !important
}

@media (max-width: 600px) {
  #centered h2 {
    font-size: 18px;
  }

  #centered button {
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
    border-radius: .2rem;
  }

  #detail h4 {
    font-size: 18px;
  }

  #detail {
    padding: 25px;
  }
}
</style>
